import { Box, Center } from "../../../components/utils";

function Avatar({
  name,
  status,
  isDark,
  profileImage,
}: {
  name: string;
  status?: string;
  isDark?: boolean;
  profileImage?: string;
}) {
  return (
    <Center className="relative w-9 h-9 loader-linear ">
      {profileImage ? (
        <Center>
          <div className="relative w-10 h-10 border rounded-full overflow-hidden">
            <img
              src={profileImage || ""}
              alt="Profile"
              className="w-full h-full object-contain"
            />
          </div>
        </Center>
      ) : (
        <Center
          className={`flex w-8 h-8 rounded-full
         ${isDark ? "bg-gray-100 text-gray-700" : "bg-profileIcon text-white"}
        `}
        >
          <p className="text-base font-bold">{name.charAt(0).toUpperCase()}</p>
        </Center>
      )}
      {status && status !== "Employed" ? (
        <Box
          className="absolute bottom-0 right-0 flex w-2.5 h-2.5
         bg-red-500 border-2 border-white rounded-full "
        ></Box>
      ) : (
        ""
      )}
    </Center>
  );
}
export default Avatar;
